import axios from 'axios'

let token = localStorage.getItem('token')
if (token === null) {
  token = ''
}

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'X-Auth-Token': token
  }
})

export default instance
